import { render, staticRenderFns } from "./InibicaoAlertasEmLote.vue?vue&type=template&id=168d27d0&scoped=true&lang=pug"
import script from "./InibicaoAlertasEmLote.vue?vue&type=script&lang=js"
export * from "./InibicaoAlertasEmLote.vue?vue&type=script&lang=js"
import style0 from "./InibicaoAlertasEmLote.vue?vue&type=style&index=0&id=168d27d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168d27d0",
  null
  
)

export default component.exports